import React, { useState, useEffect } from "react";
import { ArrowLeft, PlusCircle, Eye, Edit } from "react-feather";
import { Link } from "react-router-dom";
import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { useTableSearch } from "core/Operations/useTableSearch";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { all_routes } from "Router/all_routes";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { useVehicleIndemnityCategoriesQuery } from "AppQuries/master/VehicleIndeminty/vehicleindemnity";
import { BackIcon } from "Components/UI/Icon/Icons";
const VehicleIndemnity = () => {
  const userData = useSelector(loggedInUser);
  const {
    data,
    isLoading,
    isError,
    error,
    refetch: GetItems,
  } = useVehicleIndemnityCategoriesQuery({
    companyCode: userData?.companyCode,
    isTrue: true,
  });
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const [show, setShow] = useState(false);

  const ItemData = data?.map((d, _id) => ({
    id: _id + 1,
    ...d,
  }));

  console.log(data);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "Indemnity ID",
      dataIndex: "indemnityID",
      sorter: (a, b) => a.indemnityID - b.indemnityID,
    },
    {
      title: "Company Code",
      dataIndex: "companyCode",
      sorter: (a, b) => a.companyCode - b.companyCode,
    },
    {
      title: "Indemnity Number",
      dataIndex: "indemnityNumber",
    },
    {
      title: "Indemnity Date",
      dataIndex: "indemnityDate",
      render: (date) => new Date(date).toLocaleDateString(),
      sorter: (a, b) => new Date(a.indemnityDate) - new Date(b.indemnityDate),
    },
    {
      title: "Driver Name",
      dataIndex: "driverName",
    },
    {
      title: "Driver NRIC/FIN",
      dataIndex: "driverNRICFin",
    },
    {
      title: "LTA / HDB",
      dataIndex: "ltA_HDB",
    },
    {
      title: "Notice Number",
      dataIndex: "noticeNumber",
    },
    {
      title: "Vendor",
      dataIndex: "vendor",
    },
    {
      title: "Invoice Number",
      dataIndex: "invoiceNumber",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a, b) => a.amount - b.amount,
      render: (val) => `$${(val ?? 0).toFixed(2)}`,
    },
    {
      title: "Incident Address",
      dataIndex: "incidentAddress",
    },
    {
      title: "Issued By",
      dataIndex: "issuedBy",
    },
    {
      title: "Designation",
      dataIndex: "designation",
    },
    {
      title: "Issuer NRIC",
      dataIndex: "issuerNRIC",
    },
    {
      title: "Debit Staff Amount",
      dataIndex: "debitStaffAmount",
      sorter: (a, b) => a.debitStaffAmount - b.debitStaffAmount,
      render: (val) => `$${(val ?? 0).toFixed(2)}`,
    },
    {
      title: "Write-off Amount",
      dataIndex: "writeOffAmount",
      sorter: (a, b) => a.writeOffAmount - b.writeOffAmount,
      render: (val) => `$${(val ?? 0).toFixed(2)}`,
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    {
      title: "Vehicle Number",
      dataIndex: "vehicleNumber",
    },
    {
      title: "Status",
      dataIndex: "isActive",
      render: (text) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="add-new-tooltip">Edit</Tooltip>}
          >
            <Link
              className="me-2 p-2"
              to={`${all_routes.master}/${all_routes.editvehicleindemnity}`}
            >
              <Edit className="feather-edit" />
            </Link>
          </OverlayTrigger>
        </div>
      ),
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    ItemData,
    searchColumns
  );

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* <Breadcrumbs maintitle="Call History" subtitle="Manage your products" /> */}
          <div className="page-header">
            <div className="page-title">
              <h4>Company Vehicle Indemnity Details</h4>
              {/* <nav aria-label="breadcrumb">
                <ol className="breadcrumb breadcrumb-arrow mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/">
                      <i className="fas fa-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="..">Master</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    CPF Contributions
                  </li>
                </ol>
              </nav> */}
            </div>
            <div className="page-btn" style={{ display: "flex" }}>
              <Link
                to={`${all_routes.master}/${all_routes.addvehicleindemnity}`}
                className="btn btn-added"
              >
                
                <PlusCircle className="me-2" />
                Add
              </Link>
              &nbsp;
              <Link
                to={`${all_routes.master}`}
                className="btn btn-secondary"
              >
       <i className="fas fa-reply me-2"></i>
                Back
              </Link>
            </div>
          </div>

          
          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
              />

              <div className="table-responsive">
                <Table
                  className="table  datanew"
                  columns={columns}
                  dataSource={filteredData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VehicleIndemnity;
